module.exports = __webpack_public_path__ + "static/media/18_negro.b8f0778b.svg";